export default "__VITE_ASSET__BpsvlZRx__"